import React from "react";

function Payment() {
  return (
    <div>
      {/* <iframe src="https://magetsi.co.zw/billers/friends-of-karanda-mission-hospital/purchase/TVRrPQ==" 
    width="80%" 
    height="600px" 
    style={{border: "none"}}
    onload="this.contentWindow.document.querySelectorAll('body *:not(.blog-post)')[0].style.display='none';">
</iframe> */}
    </div>
  );
}

export default Payment;
